<template>
  <div>
    <gj-table
        name="storageArgs"
        :data="tableData"
        :columns="columns"
        :show-overflow="false"
        :loading="loading">
      <template v-slot:content="{ row }">
        <template>
          <gj-select
              v-model="row.content"
              :options="[
                {id: 'CLOSE', text: '关闭'},
                {id: 'START', text: '开启'},
              ]"
              :clearable="false"
              width="200px"
              @input="updateConfig($event, row)">
          </gj-select>
        </template>
      </template>
    </gj-table>
  </div>
</template>

<script>
  import {queryMixin, responseMixin} from "../../../../../../minxins";
  import {queryBusinessConfiguration, updateBusinessConfiguration} from "@/api/purchase";
  import {isMeaningful} from "../../../../../../utils/common";

  export default {
    name: "app-storage-args",
    mixins: [queryMixin, responseMixin],
    data() {
      return {
        tableData: [],
        columns: [
          {id: 'name', header: '参数名称', field: 'option:name', minWidth: '200px', options: [
              {id: 'PURCHASE_PLAN_REVIEW_SETTING', text: '采购计划审批设置'},
              {id: 'SHIP_PLAN_REVIEW_SETTING', text: '发货计划审核设置'}
            ]},
          {id: 'content', header: '配置项', field: 'slot:content', minWidth: '200px'},
          {id: 'memo', header: '指标配置说明', field: 'memo', minWidth: '400px'},
          {id: 'updateTime', header: '更新时间', field: 'updateTime', width: '200px'},
        ],
      }
    },
    methods: {
      updateConfig(content, row) {
        updateBusinessConfiguration({
          id: row.id,
          content,
          name:row.name,
          memo: row.memo
        })
          .then((res) => {
            this.$gjResponseHandle(res, () => {
               this.$gjMessage.success('更新成功');
            });
          }).complete(()=>{
               this.$gjQuery();
        });
      },
      $gjQuery() {
        // 查询
        this.loading = true;
        queryBusinessConfiguration()
          .then((data) => {
            if (isMeaningful(data)) {
              this.tableData = data;
            } else {
              this.tableData = [];
            }
          })
          .complete(() => {
            this.loading = false;
          });
      },
    }
  }
</script>

<style scoped>

</style>

